import * as types from '../../../../constants/ActionNameConstants';

export const userLoginRequest = (payload) => {
  return {
    type: types.VALIDATE_LOGIN_USER_REQUEST,
    payload,
  };
};

export const userLoginSuccess = (payload) => ({
  type: types.VALIDATE_LOGIN_USER_SUCCESS,
  payload,
});

export const userLoginFailure = (error) => ({
  type: types.VALIDATE_LOGIN_USER_FAILED,
  error,
});
